/**
 * Configures UI Router
 *
 * @type {ngConfig}
 */
function tmrUiRouterConfig(
  $locationProvider,
  $urlMatcherFactoryProvider,
  tmrRouterHtml5Mode
) {
  'ngInject'
  // Support clean URLs. tmrRouterHtml5Mode is an Environment constant.
  if (tmrRouterHtml5Mode) $locationProvider.html5Mode(true)

  // Allow trailing slashes in urls.
  $urlMatcherFactoryProvider.strictMode(false)
}

export { tmrUiRouterConfig as config }
